/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { GmoneyIco, HeartIco, ScashIco } from '@shared/Icon/MoneyIcon'
import { MoneyInfoWrap } from './index.style'

const MoneyInfo: React.FC = () => {
  return (
      <MoneyInfoWrap>
        <li className="info-list">
          <GmoneyIco />
          <span className="info-txt">
            머니
            <br/>
            베팅에 사용되는 재화
          </span>
        </li>
        <li className="info-list">
          <ScashIco />
          <span className="info-txt">
            캐시
            <br/>
            G머니 구매 시 사용되는 재화
            <br/>
            <span className="sub-txt">(홈페이지에서 충전 가능)</span>
          </span>
        </li>
        <li className="info-list heart">
          <HeartIco />
          <span className="info-txt">
            하트
            <br/>
            이벤트로 획득하는 아이템
            <br/>
            <span className="sub-txt">(아이템샵에서 G머니 교환 가능)</span>
          </span>
        </li>
      </MoneyInfoWrap>
  )
}

export default observer(MoneyInfo)
